<template>
  <v-row
    class="asc-dynamic-counter-wrapper--container"
    data-automation-id="wrapper_dynamic_counter"
    no-gutters
  >
    <v-col
      v-if="items && items.length"
      class="asc-dynamic-counter-wrapper--content"
    >
      <asc-dynamic-counter
        v-for="(item, index) in items"
        :key="index"
        :label="item.label"
        :location="item.link"
        :value="item.value"
        :icon="item.icon"
        :link-text="getLinkText"
      />
    </v-col>
    <v-col v-else class="asc-dynamic-counter-wrapper--content">
      <asc-dynamic-counter />
    </v-col>
  </v-row>
</template>

<script>
import AscDynamicCounter from '@/components/molecules/AscDynamicCounter'

export default {
  name: 'AscDynamicCounterWrapper',

  components: {
    AscDynamicCounter,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getLinkText() {
      return 'View Data'
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-dynamic-counter-wrapper {
  &--container {
    height: 100%;
  }

  &--content {
    align-items: center;
    display: flex;
    flex-flow: column;
    height: 100%;
    justify-content: center;

    & > :first-child {
      margin-bottom: 16px;
    }

    & > :only-child {
      margin-bottom: 0;
    }
  }
}
</style>
